export default "void main() {\n  vec3 color = vec3(0.34, 0.53, 0.96);\n  gl_FragColor = vec4(color, 1.0);\n}\n";